export interface ICandidateProfile {

    "label": "Deadpool",
    "email": null,
    "id": "0194ef3d-e9d6-0000-0000-39e97411646c",
    "created_at": "2025-02-10T09:43:19.770Z",
    "updated_at": "2025-02-10T09:43:19.770Z",
    "deleted_at": null,
    "candidate_ref_id": "0194ef3d-e9ce-0000-0000-54da9e85877a",
    "upload_digest_id": null,
    "question_id": "0194ef3d-1207-0000-0000-54bb738f7441",
    "profile_version_id": null,
    "image_sm_id": null,
    "image_lg_id": null,
    "statement": null,
    "status": "APPROVED",
    "display_order": null,
    "raw": null,
    "tag_line": string,
    "image_lg": null,
    "image_sm": null,
    "tags": null

}

export enum CANDIDATE_STATUS {
    NOMINATED = "NOMINATED",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED"
}

export interface ICandidate {
    id: string;
    created_at: Date;
    title?: string;
    label: string;
    email?: string
    preferred_name?: string;
    status: CANDIDATE_STATUS;
    deleted_at?: Date;
    display_order?: number;
    tag_line?: string;
    "statement"?: string;
    "learn_more_url"?: string,
    "image_lg_url"?: string,
    "image_sm_url"?: string,
    "tags"?: null
}

